module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/funabashi_concept_03-c92e484792f4bd797f57e15d29dd13dc.jpg";